import { render } from "./WinnerDoc.vue?vue&type=template&id=5777239a&scoped=true"
import script from "./WinnerDoc.vue?vue&type=script&lang=js"
export * from "./WinnerDoc.vue?vue&type=script&lang=js"

import "./WinnerDoc.vue?vue&type=style&index=0&id=5777239a&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5777239a"]])

export default __exports__